const SUPPLIER_DASHBOARD_DESCRIPTION =
  'This is where you can examine key metrics about the supplier listed in the side-bar.';

export default SUPPLIER_DASHBOARD_DESCRIPTION;
